<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { itemService } from "../../../../services/inventoryservice/item.service";
import { categoryService } from "../../../../services/inventoryservice/category.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Item List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      itemData: {},
      categoryData: {},
      fetchingStats: false,
      title: "Item List",

    };
  },
  mounted() {
    this.loadingCategoryData();
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      itemService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.itemData = response;
        });
    },

    loadingCategoryData: function() {
      categoryService.getList('?page=0')
        .then(response => {
          this.categoryData = response;

        });
    },

    deleted: function(id) {
      itemService.remove(id)
        .then(response => {
        
          // this.itemData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "item-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'item-add'}" :title="$t('item.text')" />
    <List v-bind:dataList="itemData" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[ {name: 'price', type: 'currency', sign: '$', decimal: '.0000'}, {name: 'last_supplier_price', type: 'currency', sign: '$', decimal: '.0000'}]"
          v-bind:fields="[ `code: ${$t('item.code')}`, `name: ${$t('item.name')}`, `category: ${$t('category.text')}`, 
            `qantity: ${$t('item.quantity')}`, `unit: ${$t('general.unit-name')}`, `price: ${$t('item.price')}`, `last_supplier_price: ${$t('item.last-supplier-price')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:view="{link: 'invoice-view'}"
          v-bind:edit="{link: 'item-edit'}"
          v-bind:filter="{
            search: ['items.code', 'items.name', 'items.name_en'],
            dropdown: [{
              title: 'category.text',
              field: 'items.category_id',
              data: this.categoryData.data,
            }]
          }"
          
    />      
  </Layout>
</template>